export enum Types {
	CONSULTA_FICHA_ALUNO_REQUEST = '@EDUCACAO/CONSULTA_FICHA_ALUNO_REQUEST',
	CONSULTA_FICHA_ALUNO_SUCCESS = '@EDUCACAO/CONSULTA_FICHA_ALUNO_SUCCESS',
	CONSULTA_FICHA_ALUNO_FAILURE = '@EDUCACAO/CONSULTA_FICHA_ALUNO_FAILURE',
	CONSULTA_FICHA_ALUNO_CLEAN = '@EDUCACAO/CONSULTA_FICHA_ALUNO_CLEAN',
}

export interface ConsultaFichaAluno {
	status: number;
	data: ConsultaFichaAlunoData | null;
}

export interface ConsultaFichaAlunoData {
	sucesso: string;
	processoId: string;
	dataAlteracaoFicha: string;
	operador: string;
	justificativaDocumentos: string;
	dadosPessoais: DadosPessoais;
	documentos: Documentos;
	certidaoAntiga: CertidaoAntiga;
	certidaoNova: CertidaoNova;
	enderecoResidencial: EnderecoResidencial;
	telefones: Telefone[];
	deficiencia: Deficiencia;
	recursoAvaliacao: RecursoAvaliacao;
	listaNecessidadesEspeciais: ListaNecessidadesEspeciais[];
	irmaos: Irmao[];
	enderecoIndicativo: EnderecoIndicativo;
	indigena: Indigena;
}

interface EnderecoIndicativo {
	logradouro: string;
	numero: string;
	bairro: string;
	nomeCidade: string;
	ufCidade: string;
	latitude: string;
	longitude: string;
	cep: string;
}

interface DadosPessoais {
	numRA: string;
	digitoRA: string;
	siglaUFRA: string;
	nomeAluno: string;
	dataNascimento: string;
	codCorRaca: string;
	corRaca: string;
	codSexo: string;
	sexo: string;
	nomeMae: string;
	nomePai: string;
	nomeSocial: string;
	nomeAfetivo: string;
	filiacao3: string; // Retirado se não for necessário
	email: string;
	emailGoogle: string;
	emailMicrosoft: string;
	nacionalidade: string;
	descricaoNacionalidade: string; // Retirado se não for necessário
	codPaisOrigem: string;
	paisOrigem: string;
	dataEntradaPais: string;
	bolsaFamilia: boolean;
	quilombola: boolean;
	possuiInternet: boolean;
	possuiNotebookSmartphoneTablet: boolean;
	gemeo: boolean;
	nomeMunicipioNascimento: string;
	ufMunicipioNascimento: string;
	alunoFalecido: boolean;
	dataFalecimento: string;
	codMunicipioNascimentoDNE: string;
	doadorOrgaos: boolean;
	tipoSanguineo: string;
	codNacionalidade: string;
	codTipoIndigena: number | string;
}

interface Documentos {
	codigoINEP: string;
	cpf: string;
	numDocumentoCivil: string;
	digitoDocumentoCivil: string;
	ufDocumentoCivil: string;
	dataEmissaoDocumentoCivil: string;
	dataEmissaoCertidao: string;
	codJustificativa: string;
	numeroCns: string;
	numeroNis: string;
	isCin: boolean;
	dataEmissaoCin: string;
	// tipoCertidao: string; // Remover se não for necessário
}

interface CertidaoAntiga {
	numCertidao: string;
	livro: string;
	folha: string;
	municipioComarca: string;
	ufComarca: string;
	distritoCertidao: string;
	// tipoCertidao: string; // Remover se não for necessário
}

interface CertidaoNova {
	certMatr01: string;
	certMatr02: string;
	certMatr03: string;
	certMatr04: string;
	certMatr05: string;
	certMatr06: string;
	certMatr07: string;
	certMatr08: string;
	certMatr09: string;
}

interface EnderecoResidencial {
	logradouro: string;
	numero: string;
	areaLogradouro: string;
	complemento: string;
	bairro: string;
	nomeCidade: string;
	ufCidade: string;
	latitude: string;
	longitude: string;
	cep: string;
	codMunicipioDNE: string;
	codAreaLogradouro: string;
	codLocalizacao: string;
	codLocalizacaoDiferenciada: string;
	localizacaoDiferenciada: string;
}

export interface Telefone {
	dddNumero: string;
	numero: string;
	tipoTelefone: string;
	descTipoTelefone: string;
	complemento: string;
	sms: boolean;
}

export interface Deficiencia {
	mobilidadeReduzida: string | boolean;
	tipoMobilidadeReduzida: string;
	dataInicioMobilidadeReduzida: string;
	dataFimMobilidadeReduzida: string;
	codigoNivelSuporte: number | string;
	profissionalApoioEscolarVO: {
		profissionalApoioEscolar: boolean;
		atividadeDiaria: boolean;
		atividadeEscolar: boolean;
		apoioHigiene: boolean;
		apoioLocomocao: boolean;
		apoioAlimentacao: boolean;
		apoioBanheiro: boolean;
		apoioMedicamento: boolean;
		dataInicioVigenciaAtividadeDiaria: string;
		dataFimVigenciaAtividadeDiaria: string;
		dataInicioVigenciaAtividadeEscolar: string;
		dataFimVigenciaAtividadeEscolar: string;
	};
}

interface RecursoAvaliacao {
	guiaInterprete: boolean;
	interpreteLibras: boolean;
	leituraLabial: boolean;
	nenhum: boolean;
	provaAmpliada: boolean;
	fonteProva: string; // Verificar se necessário
	fonteProva18: boolean;
	fonteProva20: boolean;
	provaBraile: boolean;
	auxilioTranscricao: boolean;
	auxilioLeitor: boolean;
	provaVideoLibras: boolean;
	cdAudioDefVisual: boolean;
	provaLinguaPortuguesa: boolean;
	tamanhoFonte: string;
}

export interface ListaNecessidadesEspeciais {
	codigoNecessidadeEspecial: string;
	nomeNecessidadeEspecial: string;
}

export interface Irmao {
	nomeAluno: string;
	dataNascimento: string;
	numeroRA: string;
	digitoRA: string;
	siglaUFRA: string;
	gemeo: boolean;
}

export interface RequestConsultaFichaAluno {
	numeroRA: string;
	digitoRA: string;
	siglaUFRA: string;
}

export interface Indigena {
	codTipoIndigena: string;
	tipoIndigena: string;
}
